const expectedEntityRootPaths = ['tanks', 'devices'] as const;

export function isExpectedEntityRootPath(
    entityRootPath?: string,
): entityRootPath is (typeof expectedEntityRootPaths)[number] {
    return expectedEntityRootPaths.some((expectedRootPath) => entityRootPath === expectedRootPath);
}
